/** Maximum allowed size for a single attachment file (100 MB in bytes). */
export const ATTACHMENT_MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024; // 104,857,600

/** Human-readable label shown in error messages and helper text. */
export const ATTACHMENT_MAX_FILE_SIZE_LABEL = '100 MB';

/**
 * Returns true when the given File is within the attachment upload limit.
 * Intended for use in Zod refinements and component-level guards.
 */
export const isWithinAttachmentSizeLimit = (file: File): boolean =>
  file.size <= ATTACHMENT_MAX_FILE_SIZE_BYTES;

/**
 * Zod refinement predicate for an array of File objects.
 * Returns true when every file is within the attachment size limit.
 */
export const allFilesWithinAttachmentSizeLimit = (files: File[]): boolean =>
  files.every(isWithinAttachmentSizeLimit);
